var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tree',{attrs:{"tree-data":_vm.tree,"enable-edit":_vm.enableEdit,"enable-link":_vm.enableLink},on:{"newitem":_vm.newitemfunc,"delitem":_vm.delitemfunc,"edititem":_vm.edititemfunc,"itemclick":_vm.itemclickfunc}})}
var staticRenderFns = []

export { render, staticRenderFns }